<script>
    import {links} from "svelte-routing";

    export let config;

    let footerItems = loadFooterItems();

    function loadFooterItems() {
        return fetch(config.model_root + 'shared/menu/load_menu_items.php?footer=1', {
            method: "GET"
        })
            .then(response => response.json());
    }
</script>

<div class="footer mt-5" use:links>
    <div class="white-background"></div>
    <div class="container">
        <div class="text-container">
            <h3 class="footer-title">Bleiben Sie verbunden!</h3>
            <nav class="footer-nav">
                {#await footerItems}
                    <div class="px-2 py-2 text-secondary text-center w-100 d-none">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                {:then data}
                    <ul class="footer-nav-list">
                        {#each data as item}
                            {#if item.mparent === null}
                                <li class="footer-nav-item"><a class="footer-nav-link"
                                                               href="/site/{item.urlname}-m-{item.mid}">{item.mname}</a>
                                </li>
                            {/if}
                        {/each}
                    </ul>
                {:catch error}
                    <p class="text-muted mt-2 py-2 bg-light rounded border">
                        <i class="fas fa-exclamation-triangle pe-1"></i> Fehler beim Laden der Navigation
                    </p>
                {/await}
            </nav>
            <div class="social-media">
                <a class="social-link" href="https://www.facebook.com/p/Dorfladen-Gungolding-100077446190522/" target="_blank" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
                <a class="social-link" href="https://www.instagram.com/dorfladengungolding/" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            </div>
            <div class="footer-creator">
                <small>
                    <a class="nav-link text-secondary fw-light" href="https://www.maleck.org/de/" target="_blank">
                        <div class="py-2">
                            <img src="https://www.maleck.org/us/img/logo_v3_test.png" class="maleck-icon me-1">
                            Konzeption, Entwicklung & Design der Website: Moritz Maleck Webdesign
                        </div>
                    </a>
                </small>
            </div>
        </div>
    </div>
</div>

<style>
    .footer {
        position: relative;
        background-color: #93c12a;
        color: black;
        padding: 40px 0 40px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .white-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        border-radius: 15% 15% 0 0; /* Rundungen oben */
        z-index: 0; /* Hinten im Layout */
    }

    @media (min-width: 576px) {
        .footer {
            padding: 80px 0 40px;
        }
        .white-background {
            border-radius: 50% 50% 0 0; /* Rundungen oben */
        }
    }

    .container {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-left: 40px;
        padding-right: 40px;
        width: 100%;
        max-width: 1200px; /* Set a max-width for responsiveness */
        z-index: 1; /* Vor der weißen Hintergrund-Div */
    }

    .text-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .footer-title {
        font-family: 'Dancing Script', cursive;
        font-size: 1.7rem;
        margin-bottom: 25px;
    }

    .footer-nav-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: block;
        gap: 15px;
    }

    @media (min-width: 576px) {
        .footer-nav-list {
            display: flex;
        }
    }

    .footer-nav-item {
        font-size: 1rem;
    }

    .footer-nav-link {
        text-decoration: none;
        color: black;
        display: inline-block; /* Sicherstellen, dass Links bündig sind */
        padding: 8px; /* Innenabstand für klickbare Fläche */
        border-radius: 5px; /* Rundung für den Hover-Effekt */
        background-color: #f8f8f8; /* Leicht grauer Hintergrund */
        transition: background-color 0.3s, color 0.3s; /* Übergang für Hintergrund und Farbe */
        margin-bottom: 10px;
    }

    .footer-nav-link:hover {
        background-color: #dcdcdc; /* Hintergrundfarbe beim Hover */
        color: black; /* Textfarbe bleibt schwarz */
    }

    @media (min-width: 576px) {
        .footer-nav-link {
            margin-bottom: 0px;
        }
    }

    .social-media {
        margin-top: 15px;
    }

    .social-link {
        text-decoration: none;
        color: black;
        margin-right: 15px;
        font-size: 1.5rem; /* Größe der Icons */
        transition: color 0.3s;
    }

    .social-link:hover {
        color: #85c72c; /* Farbe beim Hover ändern */
    }

    .social-link i {
        margin: 0; /* keine margin für die Icons */
    }

    .footer-creator {
        margin-top: 20px;
        background: linear-gradient(to left, rgba(237,236,232,.95) 50%, #2f3e52 50%) right;
        background-size: 201%;
        transition: .5s ease-out;
        border-radius: 5px;
    }
    .footer-creator:hover {
        background-position: left;
    }
    .footer-creator a {
        transition: .5s ease-out;
    }
    .footer-creator a:hover {
        text-decoration: none;
        color: #fff !important;
    }
    .maleck-icon {
        height: 26px;
        border-radius: 2px;
        overflow: hidden;
        margin-top: -3px;
        transition: .5s ease-out;
        display: block;
        margin-bottom: 8px;
    }
    .footer-creator:hover  .maleck-icon {
        filter: brightness(0) invert(1);
    }
    @media (min-width: 576px) {
        .maleck-icon {
            display: inline-block;
            margin-bottom: 0px;
        }
    }
</style>
